export class ConfigDB {
	static data = {
	 settings: {
		 layout_type: 'ltr',
		 sidebar: {
			type: 'default'
			},
		},
		 color: {
				layout_version: 'light', 
				color: 'color-6', 
				primary_color: '#256BEB', 
				secondary_color: '#8A75E1', 
				mix_layout: 'color-only', 
			},

		 router_animation: 'none'
	 }
	 }


export default ConfigDB;